export const groupNames = {
  allGroups: "All groups"
};
